module.exports = __webpack_public_path__ + "media/images/core_values/efficiency-0844edb1c40b26409b686d7b3498a304.png";